module.exports = require("./lib/menubuilder");



/** WEBPACK FOOTER **
 ** ./~/menu-builder/index.js
 **/